import { render, staticRenderFns } from "./CompanyBasicInformation.vue?vue&type=template&id=16a566ce&scoped=true"
import script from "./CompanyBasicInformation.vue?vue&type=script&lang=js"
export * from "./CompanyBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./CompanyBasicInformation.vue?vue&type=style&index=0&id=16a566ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a566ce",
  null
  
)

export default component.exports